import { render } from "./SuitMorph.vue?vue&type=template&id=d6e6c6bc&scoped=true"
import script from "./SuitMorph.vue?vue&type=script&lang=js"
export * from "./SuitMorph.vue?vue&type=script&lang=js"

import "./SuitMorph.vue?vue&type=style&index=0&id=d6e6c6bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e6c6bc"]])

export default __exports__